import { useSettings, useStyles } from '@wix/tpa-settings/react';
import settingsParams, {
  uninitializedNumberSettingValue,
} from '../settingsParams';
import stylesParams from '../stylesParams';
import { VisibilityKey } from './types';

export function useNumberStyleCheck() {
  const settings = useSettings();
  const styles = useStyles();

  return {
    getNumberStyleValue(key: VisibilityKey): number {
      const settingsValue = settings.get(settingsParams[key]) as number;

      if (settingsValue !== uninitializedNumberSettingValue) {
        return settingsValue;
      }

      const styleValue = styles.get(stylesParams[key]);
      return typeof styleValue === 'number' ? styleValue : 0;
    },
  };
}
